import RichText, { isDeltaEmpty } from './PageBuilder/RichText';

export default RichText;
export { isDeltaEmpty };
